import { 
    Directive,
    Inject,
    ElementRef,
    Input,
    OnInit,
    OnDestroy,
    OnChanges,
    Renderer2,
    AfterViewInit, 
    ViewChild,
    PLATFORM_ID 
} from '@angular/core';

import { Observable } from 'rxjs';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/fromEvent';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';


@Directive({ selector: '[is-on-screen]' })
export class IsOnScreen implements OnInit {

    @Input() ready: boolean;
    private isServer: boolean;
    private scrollPos: Subscription;
    private deviceType : DeviceInfo;
    
    constructor(
        @Inject(PLATFORM_ID) platformId: string,
        private el: ElementRef,
        @Inject(DEVICE_INFO) device: DeviceInfo,
        private renderer: Renderer2
        ) {
            this.el = el;
            this.isServer  = isPlatformServer(platformId); 
            this.deviceType = device;
    }

    private isMobile(): boolean {
        return this.deviceType.isMobile;
    }
    ngOnDestroy(){
        if( this.scrollPos ){
            this.scrollPos.unsubscribe();
        }
    }
    ngAfterViewInit(){
        let self = this;
        if( this.isMobile()  &&  !this.isServer ){
            this.scrollPos = Observable.fromEvent(window, "scroll").subscribe(
                function(e){
                    let top = self.el.nativeElement.getBoundingClientRect().top;
                    if( top < window.screen.availHeight && top > 0 && self.ready){
                   
                       self.el.nativeElement.classList.add("fade-out");
                       self.scrollPos.unsubscribe();
                    }    
                },
                function(err){
                    console.log(err)
                },
                function(){
                    //console.log("complete")
                }
            )
        }
    }
    ngOnInit() {
       
    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-directives/is-on-screen.directive.ts